import type { Graph, GraphId } from '../../../types';
import type { GraphCommand } from './commands';

export type EffectBuilder = (args: {
  before: Readonly<Graph>;
  after: Readonly<Graph>;
  command: GraphCommand;
}) => CommandEffect[];

export type InverseDecorator = (args: {
  before: Readonly<Graph>;
  after: Readonly<Graph>;
  command: GraphCommand;
  inverse: GraphCommand;
}) => GraphCommand;

export enum CommandEffectKind {
  // If a reference to a graph is deleted (for example by switching option types),
  // we have to clean up the graph to prevent dangling references.
  DeleteGraph = 'delete_graph',
  // Restore a soft-deleted graph when a reference comes back.
  RestoreGraph = 'restore_graph',
}

/**
 * Optional effects produced by command executions. These can either
 * be UI or state effects. We need these effects because commands are pure:
 * They have no knowledge or access to the React state.
 */
export type CommandEffect =
  | {
      kind: CommandEffectKind.DeleteGraph;
      graphId: GraphId;
    }
  | {
      kind: CommandEffectKind.RestoreGraph;
      graphId: GraphId;
    };
